module.exports = __webpack_public_path__ + "media/flags/az-b685312e.svg";